'use client'
import HeroWidget, {
  HeroWidgetProps,
  HeroWidgetWrapperProps
} from 'storefront-modules/widgets/components/HeroWidget'
import { FC, useMemo } from 'react'
import { GrandAspectRatio } from 'ui'
import { Flex, FlexProps } from '@chakra-ui/react'
import { useUIGlobalsContext } from 'ui/lib/ui-globals/hooks'

type CustomHeroWidgetProps = HeroWidgetProps

const Wrapper: FC<HeroWidgetWrapperProps> = ({ type, children, ...props }) => {
  const { mobileItemHeight } = useUIGlobalsContext()
  if (type === 'RATIO') {
    return (
      <GrandAspectRatio<FlexProps, 'w'>
        breakpoints={{
          base: '4:3',
          sm: '16:9',
          md: '33:10'
        }}
        {...props}>
        {children}
      </GrandAspectRatio>
    )
  }
  return (
    <Flex
      h={{ base: mobileItemHeight, md: 'auto' }}
      pb="30%"
      position="relative"
      w="full"
      {...props}>
      {children}
    </Flex>
  )
}

export const CustomHeroWidget = ({ ...props }: CustomHeroWidgetProps) => {
  const customProps = useMemo<CustomHeroWidgetProps['customProps']>(
    () => ({
      customComponents: {
        Wrapper
      }
    }),
    []
  )

  return <HeroWidget customProps={customProps} {...props} />
}
